import { useQuery, useQueryClient } from "@tanstack/react-query";
import api from "@/lib/api";

export function useMasterList(listType, { parentId, includeInactive = false } = {}) {
  return useQuery({
    queryKey: ["master", listType, parentId || null, includeInactive],
    queryFn: async () => {
      const params = {};
      if (parentId !== undefined) params.parent_id = parentId;
      if (includeInactive) params.include_inactive = true;
      const { data } = await api.get(`/master-data/${listType}`, { params });
      return data;
    },
    enabled: !!listType && (parentId === undefined || parentId !== null),
    staleTime: 30_000,
  });
}

export function useInvalidateMaster() {
  const qc = useQueryClient();
  return (listType) =>
    qc.invalidateQueries({ queryKey: ["master", listType] });
}
